module.exports = __webpack_public_path__ + "static/media/turnkey_small_banner.60962ab7.jpg";